// extracted by mini-css-extract-plugin
export var closeButton = "_ox-2";
export var closeButtonIcon = "_ox-3";
export var lightboxContent = "_ox-1";
export var lightboxOverlay = "_ox-0";